import { ISilentAuth, MsaImplicitAuthScope } from '@notes/webintegrations-common'
import { IGetToken } from './IGetToken'

export class MsaGetToken implements IGetToken {
  msaSilentAuth: ISilentAuth

  constructor(msaSilentAuth: ISilentAuth) {
    this.msaSilentAuth = msaSilentAuth
  }

  async getSubstrateNotesToken(): Promise<string> {
    return await this.getAccessTokenForScopes([MsaImplicitAuthScope.NotesInternalReadWrite])
  }

  async getGraphUserInfoToken(): Promise<string> {
    return await this.getAccessTokenForScopes([MsaImplicitAuthScope.GraphUserRead])
  }

  async getOneNoteUserInfoToken(): Promise<string> {
    return await this.getAccessTokenForScopes([MsaImplicitAuthScope.OneNoteUpdate])
  }

  // tslint:disable-next-line: no-any
  private async getAccessTokenForScopes(scopes: any): Promise<string> {
    const tokenInfo = await this.msaSilentAuth.getToken(scopes)
    return tokenInfo.accessToken
  }
}
